import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-subscripton-history',
  templateUrl: './subscripton-history.component.html',
  styleUrls: ['./subscripton-history.component.scss']
})
export class SubscriptonHistoryComponent implements OnInit {
	displayedColumns: string[] = ['name', 'price', 'duration', 'status', 'cancel_at'];
    dataSource = new MatTableDataSource<any>(this.data.history);

  constructor(
    public dialogRef: MatDialogRef<SubscriptonHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
